"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _usePrefixCls = require("../_utils/hooks/usePrefixCls");
// 在这里引入 tea-portal 组件，样式在 style/index.ts 中引入
// import Avatar from '@tencent/tea-portal/lib/Avatar';

// 在这里引入其他组件，样式在 style/index.ts 中引入
// import Button from '../Button';
var LayoutHeader = function LayoutHeader(props) {
  var className = props.className,
    style = props.style,
    children = props.children;
  var prefixCls = (0, _usePrefixCls.usePrefixCls)('layout__header');
  var classes = (0, _classnames.default)(prefixCls, className);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes,
    style: style
  }, children);
};
var _default = LayoutHeader;
exports.default = _default;